/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        loadingIndicator: {
            circular: {
                track: {
                    color: {
                        value: "#6f7377",
                        type: "color",
                    },
                },
                indicator: {
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                },
                xs: {
                    height: {
                        value: "16px",
                        type: "dimension",
                    },
                    width: {
                        value: "16px",
                        type: "dimension",
                    },
                    track: {
                        strokeWidth: {
                            value: "0.5px",
                            type: "dimension",
                        },
                    },
                    indicator: {
                        strokeWidth: {
                            value: "2px",
                            type: "dimension",
                        },
                    },
                },
                sm: {
                    height: {
                        value: "20px",
                        type: "dimension",
                    },
                    width: {
                        value: "20px",
                        type: "dimension",
                    },
                    track: {
                        strokeWidth: {
                            value: "0.5px",
                            type: "dimension",
                        },
                    },
                    indicator: {
                        strokeWidth: {
                            value: "2px",
                            type: "dimension",
                        },
                    },
                },
                md: {
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                    width: {
                        value: "24px",
                        type: "dimension",
                    },
                    track: {
                        strokeWidth: {
                            value: "0.5px",
                            type: "dimension",
                        },
                    },
                    indicator: {
                        strokeWidth: {
                            value: "2px",
                            type: "dimension",
                        },
                    },
                },
                lg: {
                    height: {
                        value: "34px",
                        type: "dimension",
                    },
                    width: {
                        value: "34px",
                        type: "dimension",
                    },
                    track: {
                        strokeWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                    },
                    indicator: {
                        strokeWidth: {
                            value: "2.5px",
                            type: "dimension",
                        },
                    },
                },
                xl: {
                    height: {
                        value: "42px",
                        type: "dimension",
                    },
                    width: {
                        value: "42px",
                        type: "dimension",
                    },
                    track: {
                        strokeWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                    },
                    indicator: {
                        strokeWidth: {
                            value: "3px",
                            type: "dimension",
                        },
                    },
                },
                "2xl": {
                    height: {
                        value: "54px",
                        type: "dimension",
                    },
                    width: {
                        value: "54px",
                        type: "dimension",
                    },
                    track: {
                        strokeWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                    },
                    indicator: {
                        strokeWidth: {
                            value: "3.5px",
                            type: "dimension",
                        },
                    },
                },
            },
            linear: {
                track: {
                    height: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingTop: {
                        value: "4px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "4px",
                        type: "dimension",
                    },
                    paddingLeft: {
                        value: "4px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "4px",
                        type: "dimension",
                    },
                    borderStyle: {
                        value: "solid",
                        type: "strokeStyle",
                    },
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderColor: {
                        value: "#6f7377",
                        type: "color",
                    },
                    borderRadius: {
                        value: "9999px",
                        type: "dimension",
                    },
                    backgroundColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                indicator: {
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                    height: {
                        value: "4px",
                        type: "dimension",
                    },
                    borderRadius: {
                        value: "9999px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
